import { createI18n } from 'vue-i18n';
import messages from '@/locales';

const locale = 'en';
const fallbackLocale = 'en';

const i18n = createI18n({
	locale,
	fallbackLocale,
	messages,
	legacy: false,
	globalInjection: true,
});

export default i18n;
